// extracted by mini-css-extract-plugin
export default {"mainContainer":"LicenceDetailsEditCenter_mainContainer__vnyOr","leftCol":"LicenceDetailsEditCenter_leftCol__uwnn-","fontSize":"LicenceDetailsEditCenter_fontSize__nAzGW"};